import React, { useState, useRef } from "react";
import { func } from "prop-types";
import { Formik, Form, Field } from "formik";
import { Row, Col, Collapse } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { withError } from "../../../../../components/hocs";
import { Input, FieldSpy } from "../../../../../components/formik";
import { ButtonWithSpinner } from "../../../../../components/common";
import {
  clientProfileEntriesLoading,
  filtersSelector,
} from "../../../selectors";
import { setSearchFilters } from "../../../actions";

import { clientProfileEntriesValidationSchema } from "../../../validation-schemas";
import "./searchClientProfileEntriesForm.css";
import { CollapseButton, CollapseOpenIcon } from "../../../../../assets";
import Clickable from "../../../../../components/common/Clickable";
import { logTypeOptions } from "../../../../log/constants/logTypeConstants.js";
import { CLIENT_REPORT_FILTERS } from "../../../constants/clientProfileEntryConstants.js";
import { checkTargetType } from "../../../../../utilities/common.js";
import ButtonSelectSingleClient from "../../../../../components/formik/client-profile-button-select/ButtonSelectSingleClient.jsx";
import { mainClientTypeSelector } from "../../../../../selectors/getScoreCardByTypeSelectors.js";

const ErrorInput = withError(Input);

const initialFilters = {
  categoryType: null,
  clientName: "",
  clientNumber: "",
};

const SearchClientProfileEntriesForm = ({
  handleSubmit,
  isOpenCollapse,
  toggleCollapse,
  clientProfileEntries,
}) => {
  const dispatch = useDispatch();
  const formikRef = useRef(null);
  const [typeOfCheck, setTypeOfCheck] = useState(null);
  const [targetCategory, setTargetCategory] = useState(null);
  const [key, setKey] = useState(typeOfCheck);

  const filters = useSelector(filtersSelector);
  const clientTypes = useSelector(mainClientTypeSelector);

  const resetInitialValues = (categoryType) => ({
    categoryType: categoryType,
    clientName: "",
    clientNumber: "",
  });

  const isLoading = useSelector(clientProfileEntriesLoading);

  const handleTypeOfCheckChange = (categoryType) => {
    setTargetCategory(checkTargetType({ clientTypes, value: categoryType }));
    setTypeOfCheck(categoryType);
    dispatch(setSearchFilters(resetInitialValues(categoryType)));
    setKey(categoryType);
  };

  return (
    <Formik
      ref={formikRef}
      onSubmit={handleSubmit}
      initialValues={filters}
      key={key}
      validationSchema={clientProfileEntriesValidationSchema}
      validateOnBlur={false}
      validateOnChange={false}
    >
      {({ errors }) => (
        <div>
          <div className="client-profile-collapse-search">
            <Collapse isOpen={isOpenCollapse}>
              <Form className="search-client-profile-form">
                <div className="search-client-profile-form-inner-container">
                  <Row>
                    <Col lg={4} className="p-0">
                      <Field
                        type="text"
                        name="categoryType"
                        placeholder="Client Type"
                        component={ButtonSelectSingleClient}
                        options={clientTypes}
                        isClearable
                      />
                      <FieldSpy
                        name="categoryType"
                        onChange={handleTypeOfCheckChange}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        type="text"
                        name="clientName"
                        placeholder={
                          targetCategory === "Company"
                            ? "Company Name"
                            : "Full Name"
                        }
                        component={ErrorInput}
                      />
                    </Col>
                    <Col lg={4}>
                      <Field
                        type="text"
                        name="clientNumber"
                        placeholder={
                          targetCategory === "Company"
                            ? " Company number"
                            : "EGN"
                        }
                        component={ErrorInput}
                      />
                    </Col>
                  </Row>
                  <Row />
                  <Row>
                    <Col lg={12}>
                      <div
                        style={{ height: 50 }}
                        className="form-error-message"
                      >
                        {errors.atLeastOneOf && (
                          <React.Fragment>{errors.atLeastOneOf}</React.Fragment>
                        )}
                      </div>
                    </Col>
                    <Col lg={12} className="d-flex justify-content-center ">
                      <ButtonWithSpinner
                        id="searchClientProfileEntriesSubmitButton"
                        text="Search"
                        type="submit"
                        className="search-button-client-profile"
                        loading={isLoading}
                      />
                    </Col>
                  </Row>
                </div>
              </Form>
              <div className="search-client-profile-filters-menu-collapse-button">
                {clientProfileEntries.length ? (
                  <Clickable onClick={toggleCollapse}>
                    <CollapseButton />
                  </Clickable>
                ) : null}
              </div>
            </Collapse>
          </div>
          <div className="search-client-profile-filters-menu-collapse-button">
            <Clickable onClick={toggleCollapse}>
              {!isOpenCollapse ? <CollapseOpenIcon /> : null}
            </Clickable>
          </div>
          <div className="logs-filters-main-container">
            {Object.entries(filters).map(([key, value], i) => {
              return value ? (
                <SingleFilter key={key} filterKey={key} filterValue={value} />
              ) : null;
            })}
            {Object.values(filters).some(Boolean) ? (
              <div onClick={clearFilters} className="filters-menu-label-clear">
                Clear All
              </div>
            ) : null}
          </div>
        </div>
      )}
    </Formik>
  );

  function clearFilters() {
    dispatch(setSearchFilters(initialFilters));
    formikRef.current.setValues(initialFilters);
    setTimeout(() => {
      formikRef.current.resetForm();
    }, 100);

    toggleCollapse();
  }

  function SingleFilter({ filterKey = "", filterValue = "" }) {
    let currentValue = filterValue;
    if (filterKey === "type" && filterValue) {
      currentValue = logTypeOptions.find(
        (type) => type.value === filterValue
      ).label;
    }

    return (
      <div className="single-filter-box">
        <div className="single-filter-label">
          {CLIENT_REPORT_FILTERS[filterKey]}
        </div>
        <div className="single-filter-chip">{currentValue}</div>
      </div>
    );
  }
};

SearchClientProfileEntriesForm.propTypes = {
  handleSubmit: func.isRequired,
};

export default SearchClientProfileEntriesForm;



// WEBPACK FOOTER //
// ./src/features/client-profile/components/searching/search-form/SearchClientProfileEntriesForm.jsx